























































import { Ref, Provide, Inject, Prop, Component, Vue } from 'vue-property-decorator'
import { cloneDeep, isEqual } from 'lodash'
import { Branch } from '@/api/model/branch'
import { BranchAPI } from '@/api/backend-client'
import { BranchTarget } from '@/api/model/branch-target'
import { User } from '@/api/model/user'
import { CompanyTargetType } from '@/api/types'
import ListTargets from '@/views/Company/Settings/Teams/Edit/ListTargets.vue'
import CreateTarget from '@/views/Company/Settings/Teams/Edit/CreateTarget.vue'
import EditTarget from '@/views/Company/Settings/Teams/Edit/EditTarget.vue'

@Component({
    components: {ListTargets, CreateTarget, EditTarget},
})
export default class CompanySettingsTeamsEdit extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly teamId!: string
    team: Branch = null
    editingTeam: Branch = null
    loading: boolean = false
    saving: boolean = false
    @Ref() listTargets: ListTargets
    creatingTarget: boolean = false
    editingTarget: BranchTarget = null

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.team = await BranchAPI.get(this.teamId)
        this.editingTeam = cloneDeep(this.team)
        this.loading = false
    }

    @Provide('saveBranch')
    async save(redirect: boolean = true): Promise<void> {
        this.saving = true
        this.team = await BranchAPI.update(this.teamId, this.editingTeam)
        this.editingTeam = cloneDeep(this.team)
        await this.reloadCompany()
        this.saving = false

        if (redirect) {
            await this.$router.push({ name: 'company_settings_teams_list' })
        }
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_teams_list',
        })
    }

    routeToUser(user: User) {
        return {
            name: 'company_settings_users_edit',
            params: {
                userId: user.id,
            },
        }
    }

    get hasChanges(): boolean {
        return isEqual(this.team, this.editingTeam) === false
    }

    get usersInTeam(): User[] {
        if (!this.editingTeam) {
            return []
        }

        return this.$currentCompany.users
            .filter((user: User) => user instanceof User)
            .filter((user: User) => user.branches
                .filter(branch => branch.id === this.editingTeam.id).length > 0) as User[]
    }

    get hasTeamTargets(): boolean {
        return this.$currentCompany.targetType === CompanyTargetType.TEAM
    }

    onTargetCreate(): void {
        this.creatingTarget = true
    }

    async onTargetCreated(): Promise<void> {
        this.creatingTarget = false
        await this.listTargets.reloadTargets()
    }

    onTargetEdit(target: BranchTarget): void {
        this.editingTarget = target
    }

    async onTargetUpdated(): Promise<void> {
        this.editingTarget = null
        await this.listTargets.reloadTargets()
    }

    onTargetCancel(): void {
        this.creatingTarget = false
        this.editingTarget = null
    }
}
